module.exports = __webpack_public_path__ + "img/bc.f471ad70.png";